import React, { CSSProperties, useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

interface GoogleRecaptchaProps {
  className?: string;
  style?: CSSProperties;
  sitekey: string;
  canValidate?: boolean;
  onChange: (token: string) => void;
  onExpired?: () => void;
  onErrored?: () => void;
  type: 'v2' | 'v3' | 'v2-enterprise' | 'v3-enterprise';
}

// window.recaptchaOptions = { enterprise: true };

export const GoogleRecaptcha = (props: GoogleRecaptchaProps) => {
  const { type, canValidate, ...rest } = props;
  const recaptchaRef = useRef<any>();
  const callRef = useRef(false);

  if (!type) return null;

  if (type.includes('enterprise')) {
    window.recaptchaOptions = { enterprise: true };
  } else {
    window.recaptchaOptions = {};
  }

  const validate = async () => {
    if (
      ['v3', 'v3-enterprise'].includes(type) &&
      canValidate &&
      !callRef.current &&
      recaptchaRef.current
    ) {
      callRef.current = true;
      await recaptchaRef.current.executeAsync();
    }
  };

  useEffect(() => {
    validate();
  }, [canValidate]);

  return (
    <ReCAPTCHA ref={recaptchaRef} size={type.includes('v3') ? 'invisible' : undefined} {...rest} />
  );
};
